webpackJsonp([58411574672382],{

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(16);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Transition = __webpack_require__(39);
	
	var _Transition2 = _interopRequireDefault(_Transition);
	
	var _SiteConfig = __webpack_require__(6);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	__webpack_require__(494);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactPage = function (_Component) {
	  _inherits(ContactPage, _Component);
	
	  function ContactPage() {
	    _classCallCheck(this, ContactPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ContactPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'page-container' },
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Contact | ' + _SiteConfig2.default.siteTitle }),
	        _react2.default.createElement(
	          _Transition2.default,
	          null,
	          _react2.default.createElement(_Header2.default, { data: this.props.data }),
	          _react2.default.createElement(
	            'div',
	            { className: 'contact-banner' },
	            _react2.default.createElement('img', { src: '/banner.jpg', alt: 'banner' })
	          ),
	          _react2.default.createElement(
	            'main',
	            { className: 'contact-content' },
	            _react2.default.createElement(
	              'div',
	              { className: 'contact-row' },
	              _react2.default.createElement(
	                'div',
	                { className: 'contact-col' },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  'FIND US'
	                ),
	                _react2.default.createElement(
	                  'address',
	                  { className: 'contact-address' },
	                  '19/F, Building 2, Publishing Tower,',
	                  _react2.default.createElement('br', null),
	                  'Laoshan Distinct, Qingdao,',
	                  _react2.default.createElement('br', null),
	                  'Shandong Province, PRC'
	                ),
	                _react2.default.createElement(
	                  'address',
	                  { className: 'contact-address' },
	                  '\u5C71\u4E1C\u7701\u9752\u5C9B\u5E02\u5D02\u5C71\u533A\u51FA\u7248\u5927\u53A62\u53F7\u697C19F'
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'contact-col' },
	                _react2.default.createElement(
	                  'h1',
	                  null,
	                  'SAY HELLO'
	                ),
	                _react2.default.createElement(
	                  'dl',
	                  { className: 'contact-methods' },
	                  _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Tel'
	                  ),
	                  _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      { href: 'tel:+8653288985711' },
	                      '+86 532 8898 5711'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'dt',
	                    null,
	                    'Email'
	                  ),
	                  _react2.default.createElement(
	                    'dd',
	                    null,
	                    _react2.default.createElement(
	                      'a',
	                      { href: 'mailto:info@flatwhitemotion.com' },
	                      'info@flatwhitemotion.com'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement('div', { className: 'contact-info', dangerouslySetInnerHTML: { __html: this.props.data.markdownRemark.html } })
	          )
	        )
	      )
	    );
	  };
	
	  return ContactPage;
	}(_react.Component);
	
	exports.default = ContactPage;
	
	/* eslint no-undef: "off" */
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 494:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-jsx-e2ebf4a0d518d98e0855.js